import type { CanvasEntity, TaskData } from '../entityTypes';
import type { GlobalTasksById } from '../../stores/types';

/**
 * Build the set of valid (non-connector, non-group) entity IDs.
 * For task entities, uses the taskId from data and validates against tasksById.
 * For waypoint/textblock/textlabel/sprite, uses entity.id directly.
 */
export function buildValidEntityIds(
  rawEntities: CanvasEntity[],
  tasksById: GlobalTasksById,
): Set<string> {
  const ids = new Set<string>();
  for (const e of rawEntities) {
    switch (e.kind) {
      case 'task': {
        const td = e.data as unknown as TaskData;
        if (tasksById[td.taskId]) ids.add(td.taskId);
        break;
      }
      case 'waypoint':
      case 'textblock':
      case 'textlabel':
      case 'sprite':
      case 'image':
      case 'blocknode':
      case 'shape':
      case 'adr-trigger':
        ids.add(e.id);
        break;
    }
  }
  return ids;
}
